/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunScenariosForTransactionsByIdRangeRequest
 */
export interface InternalApiRerunScenariosForTransactionsByIdRangeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiRerunScenariosForTransactionsByIdRangeRequest
     */
    scenarioHandles: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRerunScenariosForTransactionsByIdRangeRequest
     */
    minId: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRerunScenariosForTransactionsByIdRangeRequest
     */
    maxId: number;
}

/**
 * Check if a given object implements the InternalApiRerunScenariosForTransactionsByIdRangeRequest interface.
 */
export function instanceOfInternalApiRerunScenariosForTransactionsByIdRangeRequest(value: object): value is InternalApiRerunScenariosForTransactionsByIdRangeRequest {
    if (!('scenarioHandles' in value) || value['scenarioHandles'] === undefined) return false;
    if (!('minId' in value) || value['minId'] === undefined) return false;
    if (!('maxId' in value) || value['maxId'] === undefined) return false;
    return true;
}

export function InternalApiRerunScenariosForTransactionsByIdRangeRequestFromJSON(json: any): InternalApiRerunScenariosForTransactionsByIdRangeRequest {
    return InternalApiRerunScenariosForTransactionsByIdRangeRequestFromJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByIdRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunScenariosForTransactionsByIdRangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandles': json['scenarioHandles'],
        'minId': json['minId'],
        'maxId': json['maxId'],
    };
}

export function InternalApiRerunScenariosForTransactionsByIdRangeRequestToJSON(json: any): InternalApiRerunScenariosForTransactionsByIdRangeRequest {
    return InternalApiRerunScenariosForTransactionsByIdRangeRequestToJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByIdRangeRequestToJSONTyped(value?: InternalApiRerunScenariosForTransactionsByIdRangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandles': value['scenarioHandles'],
        'minId': value['minId'],
        'maxId': value['maxId'],
    };
}

